import React from 'react';
import { MapPin } from 'lucide-react';

const NoTransmissionDataState = () => (
  <div className="flex items-center justify-center h-96">
    <div className="text-center text-gray-500">
      <MapPin className="h-8 w-8 mx-auto mb-4" />
      <div className="text-lg font-medium mb-2">No Transmission Data</div>
      <div className="text-sm">No transmission data available for this country.</div>
    </div>
  </div>
);

export default NoTransmissionDataState;
